import type { DateBounds } from "../types";

export function intersectDateBounds(a: DateBounds, b: DateBounds): DateBounds {
  const min =
    a.min && b.min
      ? new Date(Math.max(a.min.getTime(), b.min.getTime()))
      : a.min || b.min;
  const max =
    a.max && b.max
      ? new Date(Math.min(a.max.getTime(), b.max.getTime()))
      : a.max || b.max;

  return { min, max };
}
